import { XBrowser, XUtils, assign, isBoolean, isNumber } from './xp.v1'
import { WZ, getServerTime, getErrorMsg } from './wz.v2'

// import {
//     isArray
// } from 'util'

// import { Promise } from 'es6-promise-polyfill'

const keys = Object.keys

// TODO: deepEqual
function isSameQuery(a, b) {
  if (a && b) {
    const props = keys(a)
    const length = props.length
    if (length === keys(b).length) {
      for (let i = 0, key; i < length; i++) {
        key = props[i]
        if (!b.hasOwnProperty(key) || a[key] !== b[key]) {
          return false
        }
      }
      return true
    }
  }
  return false
}

function isOkCache(cacheData, cacheTime, mtime) {
  if (cacheData) {
    if (cacheTime === true) {
      // 命中：永久cache
      return cacheData
    } else if (cacheTime > 0) {
      const secs = (getServerTime() - mtime) / 1000
      if (cacheTime > secs && secs > 0) {
        // 命中：未过期cache
        return cacheData
      }
    }
  }
  return null
}

function formatCacheNum(cache, defaultCache) {
  return isBoolean(cache)
    ? cache
    : isNumber(cache)
    ? cache >= 0
      ? +cache
      : false
    : defaultCache
}

export function apiRegister(name, opts) {
  opts = opts || {}

  // 默认缓存多久
  const defaultCache = formatCacheNum(opts.cache, false)

  WZ.apiRegister(name, opts)

  const _Cache = {} // 缓存数据

  function updateCache(query, result, promise) {
    if (!_Cache.query || isSameQuery(_Cache.query, query)) {
      _Cache.mtime = getServerTime()
      _Cache.query = query
      _Cache.result = result
      _Cache.promise = promise
    }
  }

  return {
    clear() {
      updateCache(null, null, null)
    },
    async send(query, opts) {
      query = query || {}

      opts = assign(
        {
          cache: false
        },
        opts
      )

      // let cache = isUndefined(opts.cache) ? defaultCache : opts.cache;
      // cache = isBoolean(cache)
      //   ? cache
      //   : isNumber(cache) && cache >= 0
      //     ? cache
      //     : false;

      const cache = formatCacheNum(opts.cache, defaultCache)

      const isSameRequest = !!_Cache && isSameQuery(_Cache.query, query)

      // 相同的请求
      if (isSameRequest) {
        if (cache) {
          const cacheData = isOkCache(_Cache.result, cache, _Cache.mtime)
          if (cacheData) {
            // 命中缓存
            return Promise.resolve(cacheData)
          }
        }
        if (_Cache.promise) {
          // 上一请求未结束
          // _Cache.promise = _Cache.promise.then(r => r)
          return _Cache.promise
        }
      }

      const promise = new Promise((resolve, reject) => {
        const args = {
          name,
          query,
          // onsuccess(result) {
          //   updateCache(query, result);
          //   success(result);
          // },
          // onfail(e) {
          //   updateCache(query, null);
          //   fail(e);
          // },
          onend(Resp) {
            const isSuccess = Resp.isSuccess
            const Body = Resp.Body
            if (isSuccess) {
              updateCache(query, Body, null)
              resolve(Body)
            } else {
              updateCache(query, null, null)
              Resp.message = getErrorMsg(Resp.code)
              reject(Resp)
            }
            // alert(JSON.stringify(Body, null, 2))
          }
        }
        WZ.apiSend(args)
      })

      updateCache(query, null, promise)

      return promise
    },

    // 提交表单
    async submit(formId) {
      const promise = new Promise((resolve, reject) => {
        const args = {
          name,
          formId,
          onend(Resp) {
            const isSuccess = Resp.isSuccess
            const Body = Resp.Body
            if (isSuccess) {
              resolve(Body)
            } else {
              Resp.message = getErrorMsg(Resp.code)
              reject(Resp)
            }
            // alert(JSON.stringify(Body, null, 2))
          }
        }
        WZ.apiSubmit(args)
      })
      return promise
    }
  }
}

// export async function loadApi(name, query) {
//   return new Promise((success, fail) => {
//     WZ.apiSend({
//       name,
//       query,
//       onsuccess(r) {
//         success(r)
//       },
//       onfail(e) {
//         fail(e)
//       }
//     })
//   })
// }
let jCallbackCount = 0
export async function loadJsonp({ url, callback, cache, timeout }) {
  timeout = timeout > 0 ? +timeout : 5000
  const _jcallback =
    callback ||
    '_jcb_' +
      XUtils.md5(url).slice(0, 8) +
      '_' +
      (cache === false ? 'x' : ++jCallbackCount)
  let status = 0 // 0 加载中  200: 加载成功   504: 加载超时
  return new Promise((resolve, reject) => {
    if (!window[_jcallback]) {
      window[_jcallback] = function(res) {
        if (!status) {
          status = 200
          resolve(res)
        }
        try {
          delete window[_jcallback]
        } catch (e) {
          //
        }
      }
    }
    setTimeout(() => {
      if (!status) {
        status = 504
        reject({
          error_code: 1504
        })
      }
    }, timeout)
    XBrowser.loadJs(`${url}&_jcallback=${_jcallback}`)
  })
}
